// store.ts
import { createStore, combineReducers } from 'redux';
import { loginUserInfoReducer } from './reducers/loginUserInfoReducer';

const rootReducer = combineReducers({
    loginUserInfo: loginUserInfoReducer,
});

const store = createStore(rootReducer);

export default store;
